"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityConfig = void 0;
const activity_core_1 = require("@ark/activity-core");
const utils_1 = require("@ark/utils");
exports.activityConfig = new activity_core_1.ActivityConfig({
    apiPrefix: 'predict',
    name: '竞猜',
    description: '竞猜活动包',
    businessLocations: [
        utils_1.BusinessLocation.US,
        utils_1.BusinessLocation.CA,
        utils_1.BusinessLocation.HK,
        utils_1.BusinessLocation.SG,
        utils_1.BusinessLocation.MY,
        utils_1.BusinessLocation.JP,
        utils_1.BusinessLocation.AU,
    ],
});
